import React from 'react'
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from 'reactstrap'
import { FormControlLabel, FormGroup, Switch } from '@mui/material'

class RecurringSales extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      times: null,
      loading: true,
      saving: false,
      config: {
        saldofirst: false,
        cardafterplay: false,
      },
    }
  }

  componentDidMount() {
    this.unsubscribe = this.props.firebase.getConfig('recurringsales').onSnapshot((doc) => {
      if (doc.exists) {
        this.setState({
          config: doc.data(),
          loading: false,
        })
      } else {
        this.setState({
          loading: false,
        })
      }
    })
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  // Recurring occurrences still unpaid 30 min after they end are paid from the customer's cash saldo
  // (falcon recurring-billing.js). Organisations are left out; a customer can refuse it in their profile.
  onSaldoFirstChange = async (event) => {
    this.setState({ saving: true })
    await this.props.firebase.addConfig('recurringsales', { saldofirst: event.target.checked })
    this.setState({ saving: false })
  }

  // ... and the rest from a card the customer consented for this venue (when adding it, or in the profile), whatever
  // way the booking was sold (falcon recurring-billing.js).
  onCardAfterPlayChange = async (event) => {
    this.setState({ saving: true })
    await this.props.firebase.addConfig('recurringsales', { cardafterplay: event.target.checked })
    this.setState({ saving: false })
  }

  render() {
    if (!this.state.loading) {
      return (
        <>
          <Card>
            <CardHeader>
              <Row>
                <Col lg='10' md='5' sm='5'>
                  <CardTitle tag='h5'>Vakiovuorot</CardTitle>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {this.state.saving ? (
                <p>Tallennetaan...</p>
              ) : (
                  <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.config.saldofirst === true}
                      onChange={this.onSaldoFirstChange}
                      name='saldofirst'
                      color='primary'
                    />
                  }
                  label='Maksamattomat vakiovuorot veloitetaan asiakkaan saldosta 30 min vuoron päättymisen jälkeen (ei yritykset)'
                  />
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.config.cardafterplay === true}
                      onChange={this.onCardAfterPlayChange}
                      name='cardafterplay'
                      color='primary'
                    />
                  }
                  label='Maksamattomat vakiovuorot veloitetaan asiakkaan tallennetulta kortilta, jolle hän on hyväksynyt vakiovuorojen veloituksen (saldon jälkeen, jos saldoveloitus on päällä; ei yritykset)'
                  />
                  </FormGroup>
              )}
            </CardBody>
          </Card>
        </>
      )
    } else {
      return <></>
    }
  }
}

export default RecurringSales
